module.exports = __webpack_public_path__ + "static/media/footer-messages-active.f0d5e723.png";